import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";
import { InstagramIcon } from "../assets/icons/InstagramIcon";

const Header = () => {
  const { pathname } = useLocation();

  return (
    <header className="site-sidebar">
      <Link to="/" className="site-name">Дарья Немкович<span>фотография</span></Link>
      <nav className="sidebar-navigation" aria-label="Основная навигация">
        <Link to="/price" className="navigation-link" aria-current={pathname === "/price" ? "page" : undefined}>стоимость</Link>
      </nav>
      <ThemeToggle />
      <div className="sidebar-bottom">
        <div className="sidebar-socials">
          <a href="https://www.instagram.com/darianemkovich/" target="_blank" rel="noopener noreferrer" aria-label="Инстаграм"><InstagramIcon /></a>
        </div>
        <p>Варшава, Польша</p>
        <a className="sidebar-booking" href="https://ig.me/m/darianemkovich" target="_blank" rel="noopener noreferrer">записаться на съёмку ↗</a>
      </div>
    </header>
  );
};

export default Header;
